module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#youtube",
      toString: function () {
        return this.url;
      }
    }